import { render } from "./CaseDetails.vue?vue&type=template&id=203cd4ec&scoped=true&ts=true"
import script from "./CaseDetails.vue?vue&type=script&lang=ts"
export * from "./CaseDetails.vue?vue&type=script&lang=ts"

import "./CaseDetails.vue?vue&type=style&index=0&id=203cd4ec&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203cd4ec"]])

export default __exports__